// extracted by mini-css-extract-plugin
export default {"priceTD":"ContentBox_priceTD__Dyx7v","table":"ContentBox_table__RDOA1"};